/** 
 * Static Lean Asset Mappings
 * Uses static paths to keep the main bundle light.
 */

export const LOGO_DATA = "/logo.png?v=2";

export const AVATAR_DATA: Record<string, string> = {
    "avatar_1": "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=128&h=128&fit=crop",
    "avatar_2": "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=128&h=128&fit=crop",
    "avatar_3": "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=128&h=128&fit=crop",
    "avatar_4": "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=128&h=128&fit=crop",
    "avatar_5": "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=128&h=128&fit=crop",
    "avatar_6": "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=128&h=128&fit=crop",
    "avatar_7": "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=128&h=128&fit=crop",
    "avatar_8": "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=128&h=128&fit=crop"
};
